import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppViews } from '../../helpers/enums';
import { filterResults } from 'src/app/store/app.actions';
import { MainViewStore, MainViewState } from '../../helpers/types';

@Component({
  selector: 'app-search-without-debounce',
  templateUrl: './search-without-debounce.component.html',
  styles: [
    `
      .disabled {
        pointer-events: none;
      }
      .tip {
        position: absolute;
        right: -120px;
        top: 11px;
        font-size: 12px;
      }
    `
  ]
})
export class SearchWithoutDebounceComponent {
  @Input() placeholder = '';
  @Input() searchFieldName: string;
  @Input() state: Observable<MainViewState>;
  @Input() view: AppViews;

  searchField$: Observable<string>;
  previousSearch: string;
  searchText: string;
  searchNotApplied = false;

  constructor(private store: Store<MainViewStore>) {}

  setParam(text: string): void {
    this.searchText = text;

    // show tip
    // this.searchNotApplied = this.searchText !== this.previousSearch;
  }

  search(): void {
    this.state.pipe(take(1)).subscribe((state: MainViewState) => {
      const params = {
        ...state.params,
        [this.searchFieldName]: this.searchText,
        offset: 0
      };
      this.store.dispatch(filterResults({ params, appView: this.view }));
      this.previousSearch = this.searchText;
      this.searchNotApplied = false;
    });
  }
}
